module.exports = __webpack_public_path__ + "img/bg_main_no_data.1faf735.png";